<script lang="ts">
	interface Props {
		items: { id: string; label: string }[];
		value: string;
		label?: string;
		onchange: (value: string) => void;
	}
	let { items, value, label = 'Разделы', onchange }: Props = $props();
</script>

<div class="admin-tabs" role="group" aria-label={label}>
	{#each items as item (item.id)}
		<button
			type="button"
			class:active={value === item.id}
			aria-pressed={value === item.id}
			onclick={() => onchange(item.id)}>{item.label}</button
		>
	{/each}
</div>

<style>
	.admin-tabs {
		display: flex;
		flex-wrap: wrap;
		gap: var(--spacing-xs);
		padding: var(--spacing-xs);
		border-radius: var(--radius-m);
		background: var(--background-secondary);
	}
	button {
		min-height: var(--admin-control-height);
		padding: var(--spacing-s) var(--spacing-m);
		border: 0;
		border-radius: var(--radius-s);
		background: transparent;
		color: var(--text-secondary);
		font: inherit;
		font-size: var(--font-size-s);
		cursor: pointer;
	}
	button.active {
		background: var(--background-card);
		color: var(--text-primary);
		box-shadow: var(--shadow-s);
	}
	button:focus-visible {
		outline: var(--size-2) solid var(--accent-primary);
		outline-offset: var(--size-2);
	}
	@media (max-width: 900px) {
		button {
			min-height: var(--admin-touch-target);
			flex: 1 1 auto;
		}
	}
</style>
